import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormValidations } from 'src/app/helpers/form-validations';

@Component({
  selector: 'input-feedback',
  templateUrl: './input-feedback.component.html',
  styleUrls: ['./input-feedback.component.scss']
})
export class InputFeedbackComponent implements OnInit, OnChanges, OnDestroy {

  @Input() control: FormControl;
  @Input() label: string;
  @Input() showSuccess: Boolean;

  subs: Subscription;
  message: string;
  showSucc: boolean;

  constructor() { }

  ngOnInit() {
    try {
      this.subs = this.control.statusChanges.subscribe(status => {
        this.ErrorMessage();
      });
    } catch (error) { }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.showSucc = (changes['showSuccess']) ? changes['showSuccess'].currentValue : true;
  }

  ErrorMessage() {
    if (this.control.errors) {
      Object.keys(this.control.errors).forEach(propertyName => {
        if (this.control.value !== '' || this.control.touched) {
          // console.log('Dentro do If: ', this.control.errors.hasOwnProperty(propertyName));
          this.message = FormValidations.getErrorMsg(
            this.label,
            propertyName,
            this.control.errors[propertyName]
          );
        } else {
          this.message = null;
        }
      });
    } else {
      this.message = null;
    }
  }

  ngOnDestroy(): void {
    // this.subs.unsubscribe();
  }

}
